<template>
    <transition name="router-anim">
        <div>
            <div class="logs-container" v-show="logShow == 0">
                <div class="search-bar">
                    <img :src="isLoading ? require('@/images/dashboard/reloading-gif.svg') : require('@/images/dashboard/refresh.png')"
                        @click="reloadLogs" class="reload-icon" title="Reload Logs" />
                    <input v-model="searchQuery" @input="searchLogs" placeholder="Search by Email or Kit ID" />
                </div>

                <div v-if="isLoading" class="loading">Loading logs...</div>
                <div v-else-if="logs.length === 0" class="no-data">No logs found</div>

                <div v-else class="logs-table">
                    <table>
                        <thead>
                            <tr>
                                <th @click="sortBy('id')">
                                    LOG ID
                                    <img :src="upImg"
                                        :class="{ rotated: sortedByColumn === 'id' && sortedByState === 'asc' }" />
                                </th>
                                <th @click="sortBy('user_id')">
                                    USER ID
                                    <img :src="upImg"
                                        :class="{ rotated: sortedByColumn === 'user_id' && sortedByState === 'asc' }" />
                                </th>
                                <th>
                                    USER EMAIL
                                </th>
                                <th>
                                    Log Type
                                </th>
                                <th @click="sortBy('response_status')">
                                    RESPONSE
                                    <img :src="upImg"
                                        :class="{ rotated: sortedByColumn === 'response_status' && sortedByState === 'asc' }" />
                                </th>
                                <th>
                                    DETAILS
                                </th>
                                <th @click="sortBy('created_at')">
                                    DATE
                                    <img :src="upImg"
                                        :class="{ rotated: sortedByColumn === 'created_at' && sortedByState === 'asc' }" />
                                </th>
                                <th>
                                    ACTIONS
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(log, index) in logs" :key="index">
                                <td>{{ log.id }}</td>
                                <td>{{ log.user_id }}</td>
                                <td>{{ log.usermail }}</td>
                                <td>{{ log.log_type }}</td>
                                <td>{{ generateLogDetails(log).responseStatus }}</td>
                                <td>
                                    <span>IP: {{ generateLogDetails(log).ip }}</span> |
                                    <span>OS: {{ generateLogDetails(log).os }}</span> |
                                    <span>Browser: {{ generateLogDetails(log).browser }}</span> |
                                    <span>Device: {{ generateLogDetails(log).device }}</span> |
                                    <span>Location: {{ generateLogDetails(log).location }}</span>
                                </td>
                                <td>{{ formatDate(log.created_at) }}</td>
                                <td>
                                    <img src="@/images/dashboard/eye_black.png" @click.stop="openModal(log)"
                                        title="Detailed View" class="modal-icon" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="pogination" v-if="count_page > 1">
                    <Paginate :page-count="count_page" :page-class="'pogination-item'" :click-handler="changePage"
                        :prev-text="'<'" :next-text="'>'" :container-class="'pogination-wrap'" />
                </div>
                <LogDetailsModal :show="isModalVisible" :log="selectedLog" @close="closeModal" />
            </div>
        </div>
    </transition>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import LogDetailsModal from "./UserLogsModal.vue";
import Paginate from "vuejs-paginate";

export default {
    name: "UserLogs",
    data() {
        return {
            logs: [],
            count_page: 1,
            sortedByState: "desc",
            sortedByColumn: "id",
            logShow: 0,
            isLoading: false,
            upImg: require('../../images/dashboard/up.png'),
            searchQuery: "",
            isModalVisible: false,
            selectedLog: null
        };
    },
    components: {
        Paginate,
        LogDetailsModal
    },
    methods: {
        ...mapActions(["fetchUserLogs", "setUserLogsPage", "setSortedByAdmin", "setSerachString", "setSortedByLogs"]),
        formatDate(date) {
            return date ? moment(date).format("MM/DD/YYYY hh:mm:ss A") : "-";
        },
        changePage(page) {
            this.setUserLogsPage(page);
            this.fetchUserLogs();
        },
        async reloadLogs() {
            this.isLoading = true;
            await this.setSortedByLogs(this.sortedByColumn);
            await this.setSortedByAdmin(this.sortedByState);
            this.setUserLogsPage(1);
            await this.fetchUserLogs();
            this.isLoading = false;
        },
        sortBy(column) {
            if (this.sortedByColumn === column) {
                this.sortedByState = this.sortedByState === "desc" ? "asc" : "desc";
            } else {
                this.sortedByColumn = column;
                this.sortedByState = "asc";
            }
            this.setSortedByLogs(column).then(() => {
                this.setSortedByAdmin(this.sortedByState).then(() => {
                    this.setUserLogsPage(1);
                    this.fetchUserLogs();
                });
            });
        },
        sortByDate() {
            this.sortedByState = this.sortedByState === "desc" ? "asc" : "desc";
            this.$set(this, "sortedByState", this.sortedByState);
            this.setUserLogsPage(1);
            this.setSortedByLogs("id").then(() => {
                this.setSortedByAdmin(this.sortedByState).then(() => {
                    this.fetchUserLogs();
                });
            })
        },
        generateLogDetails(log) {
            if (!log.ua_details) return "No details available";

            const ip = log.ua_details.ip || "Unknown IP";
            const os = log.ua_details.os && log.ua_details.os.name
                ? `${log.ua_details.os.name} ${log.ua_details.os.version || ''}`.trim()
                : "Unknown OS";

            const browser = log.ua_details.browser && log.ua_details.browser.name
                ? `${log.ua_details.browser.name} ${log.ua_details.browser.version || ''}`.trim()
                : "Unknown Browser";

            const device = log.ua_details.device && log.ua_details.device.type && log.ua_details.device.type !== "Unknown"
                ? log.ua_details.device.type
                : "Unknown Device";

            const location = this.getLocationString(log.ua_details.location);
            const responseStatus = this.getResponseStatusExplanation(log.response_status);

            return {
                ip,
                os,
                browser,
                device,
                responseStatus,
                location
            };
        },
        getResponseStatusExplanation(status) {
            const responseStatusMap = {
                200: "200 ( OK )",
                201: "201 ( Created )",
                204: "204 ( No Content )",
                400: "400 ( Bad Request )",
                401: "401 ( Unauthorized )",
                403: "403 ( Forbidden )",
                404: "404 ( Not Found )",
                500: "500 ( Internal Server Error )",
                502: "502 ( Bad Gateway )",
                503: "503 ( Service Unavailable )"
            };

            return responseStatusMap[status] || `${status}: Unknown Status`;
        },
        getLocationString(locationData) {
            if (!locationData || typeof locationData !== 'object') return "Unknown Location";
            const { city, region, country } = locationData;
            return [city, region, country].filter(part => part && part !== "Unknown").join(', ') || "Unknown Location";
        },
        async searchLogs() {
            this.isLoading = true;
            this.setSerachString(this.searchQuery);
            this.setUserLogsPage(1);
            await this.fetchUserLogs();
            this.isLoading = false;
        },
        openModal(log) {
            this.selectedLog = log;
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
            this.selectedLog = null;
        }
    },
    computed: {
        ...mapGetters(["getUserLogs", "UserLogsPage"]),
    },
    watch: {
        UserLogsPage(num) {
            this.count_page = num;
        },
        getUserLogs(logs) {
            this.logs = logs;
        }
    },
    async mounted() {
        this.isLoading = true;
        this.setSortedByAdmin('desc').then(() => {
            this.fetchUserLogs();
        });
        this.isLoading = false;
        this.logs = this.$store.getters.getUserLogs
        if (this.$store.getters.UserLogsPage !== null) {
            this.count_page = this.$store.getters.UserLogsPage || 1;
        }
    }
};
</script>

<style scoped>
.logs-container {
    margin-top: 10px;
    max-width: 100%;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
    font-family: "TTNormsLight", serif;
}

.search-bar {
    margin-bottom: 15px;
    text-align: end;
}

.search-bar input {
    font-size: 14px;
    font-family: TTNormsMedium, sans-serif;
    width: 30%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #fff;
    outline: none;
    transition: all 0.5s linear;
}

.reload-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-right: 10px;
    vertical-align: middle;
}

.loading,
.no-data {
    text-align: center;
    font-size: 16px;
    color: #555;
    margin-top: 20px;
    font-weight: bold;
}

.logs-table thead {
    background-color: #005eb8;
    color: #ffffff;
    font-size: 14px;
}

.logs-table th {
    padding: 25px 25px;
    padding-left: 12px !important;
    text-align: left;
    white-space: nowrap;
    text-transform: uppercase;
    font-weight: bold;
    cursor: pointer;
}

.logs-table th img {
    margin-left: 5px;
    width: 12px;
    height: auto;
    vertical-align: middle;
}

.logs-table thead tr:first-child th:first-child {
    border-top-left-radius: 8px;
}

.logs-table thead tr:first-child th:last-child {
    border-top-right-radius: 8px;
}

.logs-table th:nth-child(1),
.logs-table td:nth-child(1) {
    width: 8%;
}

.logs-table th:nth-child(2),
.logs-table td:nth-child(2) {
    width: 10%;
}

.logs-table th:nth-child(3),
.logs-table td:nth-child(3) {
    width: 15%;
}

.logs-table th:nth-child(4),
.logs-table td:nth-child(4) {
    width: 18%;
}

.logs-table th:nth-child(5),
.logs-table td:nth-child(5) {
    width: 10%;
}

.logs-table th:nth-child(6),
.logs-table td:nth-child(6) {
    width: 18%;
}

.logs-table th:nth-child(7),
.logs-table td:nth-child(7) {
    width: 10%;
}

.logs-table th:nth-child(8),
.logs-table td:nth-child(8) {
    width: 10%;
}

.logs-table td:last-child {
    text-align: center;
    vertical-align: middle;
}

.logs-table table {
    width: 100%;
    border-collapse: collapse;
}

.logs-table td {
    padding: 10px;
    text-align: left;
    font-size: 14px;
    color: #333;
    border-bottom: 1px solid #dee2e6;
    word-break: break-word;
    white-space: normal;
}

.logs-table tbody tr:nth-child(even) {
    background: #f1f1f1;
}

.logs-table tbody tr:hover {
    background: #e2e6ea;
}

.modal-icon {
    width: 18px;
    height: 18px;
    cursor: pointer;
    margin-right: 10px;
}

.pogination {
    margin: 20px 0 0 0;
}
</style>